import {
  hideVarianceHistoryDetailsModal,
  setCollectionBreakdownModal,
} from "@actions/modals";
import collections from "@api/collections";
import DataGrid from "@shared/DataGrid";
import React from "react";
import { connect } from "react-redux";
import { Header, Modal } from "semantic-ui-react";

class SiteVarianceHistoryModal extends React.Component {
  state = {
    loading: false,
  };

  onRowClick = (row) => {
    const { detailRef } = row;
    const fnLoad = collections.getBankingWeekByEgm;
    this.props.setCollectionBreakdownModal({
      open: true,
      detailRef,
      fnLoad,
    });
    /*
    if (detailRef && detailRef.length > 0) {
      this.setState({ loading: true }, () => {
      collections.getBankingWeekByEgm(detailRef).then(
        result => {
        this.setState({ loading: false })
        this.props.setCollectionBreakdownModal(
          {
          open: true,
          detailRef,
          ...result,
          fnLoad
          },
          async () => this.onRowClick(row),
          async () => {
          this.setState({ loading: true }, () => {
            this.props.modal.onRefresh().then(() => this.setState({ loading: false }))
          })
          },
        );
        },
        error => this.setState({ loading: false })
      );
      });
    }
    */
  };

  onClose = () => {
    this.props.hideVarianceHistoryDetailsModal().then(() => {
      this.props.modal.onClose();
    });
  };

  render() {
    const { open, siteDisplay, machineDisplay } = this.props.modal;
    const { data, rowDef, headerDef } = this.props.modal.grid;
    return (
      <Modal
        open={open}
        onClose={this.onClose}
        size="fullscreen"
        closeIcon
        style={{ height: "80%" }}
      >
        <Modal.Header>Variance History Details</Modal.Header>
        <Modal.Content className="h-100 gs-flex-container-vertical">
          <Header size="small">
            {siteDisplay}
            <Header.Subheader>{machineDisplay}</Header.Subheader>
          </Header>
          <DataGrid
            loading={this.state.loading}
            headings={headerDef}
            data={data}
            rowDef={rowDef}
            onRowClick={this.onRowClick}
            fullHeight
          />
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.varianceHistoryDetailsModal,
  };
};

export default connect(mapStateToProps, {
  hideVarianceHistoryDetailsModal,
  setCollectionBreakdownModal,
})(SiteVarianceHistoryModal);
